const video_route = [
  {
    path: '/video',
    name: "video",
    component: resolve => {
      require(["@/views/video/Index.vue"], resolve);
    },
    redirect: { path: "/video/videolist" },
    meta: {
      public: false,
      title: '视频资源管理',
      navtype: 1,
    },
    children: [
      {
        path: 'videolist',
        name: "videolist",
        component: resolve => {
          require(["@/views/video/myVideo/VideoList.vue"], resolve);
        },
        meta: {
          public: false,
          title: '视频资源管理',
          navtype: 1,
          id:[10050],
          active: ['/video/videolist','/video/videoapproval']
        }
      },
      {
        path: 'videodetail',
        name: "videodetail",
        component: resolve => {
          require(["@/views/video/myVideo/VideoDetail.vue"], resolve);
        },
        meta: {
          public: false,
          title: '资源详情',
          navtype: 1,
          id:[10064],
          active: ['/video/videolist','/video/videoapproval']
        }
      },
      {
        path: 'approvalindex',
        name: "approvalindex",
        component: resolve => {
          require(["@/views/video/videoapproval/ApprovalIndex.vue"], resolve);
        },
        redirect: { path: "/video/videoapproval" },
        meta: {
          public: false,
          title: '视频资源审批',
          navtype: 1,
          active: ['/video/videolist','/video/videoapproval']
        },
        children: [
          {
            path: '/video/videoapproval',
            name: "videoapproval",
            component: resolve => {
              require(["@/views/video/videoapproval/VideoApproval.vue"], resolve);
            },
            meta: {
              public: false,
              navtype: 1,
              id:[10052],
              active: ['/video/videolist','/video/videoapproval']
            },
          },
          {
            path: '/video/applydetail',
            name: "applydetail",
            component: resolve => {
              require(["@/views/video/videoapproval/ApplyDetail.vue"], resolve);
            },
            meta: {
              public: false,
              title: '查看详情',
              id:[10052,10053],
              navtype: 1,
              active: ['/video/videolist','/video/videoapproval']
            }
          },
        ]
      }
    ],
  },
];
export default video_route